<template>
    <div class="size-change">
      <vs-dropdown vs-trigger-click class="cursor-pointer">
        <span class="show-text">{{$t('show')}}</span>
        <span class="count">{{count}}</span>
        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
        <vs-dropdown-menu>
          <vs-dropdown-item
            v-for="(item,index) in sizes"
            :key="index"
            @click="sizeChangHandle(item)">
            <span>{{item}}</span>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
</template>

<script>
    export default {
        name: "sizeChange",
      data() {
        return {
          count: 10,
          sizes: [
            10,
            20,
            50,
            100
          ]
        }
      },
      methods: {
        sizeChangHandle(size) {
          this.count = size;
          this.$emit('sizeChange', size);
        }
      },
    }
</script>

<style lang="scss" scoped>
.size-change {
  .count {
    padding: 0 10px;
  }
  .show-text {
    color: #6E6B7B;
  }
}

</style>
